export enum SerializationStrategy {
 	None = 'none',
	Inspect = 'inspect'
}

export type NativeType = 'string'  | 'number' | 'function' |  'object' | 'undefined' | 'boolean' | 'bigint' | 'symbol';
export type ValueType = string | number | boolean | null | undefined;

export interface ISerializedValue {
	nativeType?: NativeType,
	nativeName?:  string, // constructor.name
	value: ValueType,
	serializationStrategy: SerializationStrategy,
}	
